export const ADD_PAYMENT_METHOD_ID = 'add-payment-method';

export type PaymentMethodItem =
  | {
      kind: 'card';
      id: string;
      issuerName: string;
      last4: string;
      holderName: string;
      expiry?: string;
      network: string;
      networkVariant: string;
      gradientColors?: [string, string];
      /** `PaymentCardResponseDTO.paymentMethod` cuando el BFF lo informa. */
      paymentMethod?: string;
      /** Solo la tarjeta de crédito Carrefour (Mastercard); alimenta `payment_issuer` de analytics. */
      issuer?: 'carrefour';
    }
  | { kind: 'mercadopago'; id: string }
  | { kind: 'add' };

export const paymentMethodItemId = (item: PaymentMethodItem): string => {
  return item.kind === 'add' ? ADD_PAYMENT_METHOD_ID : item.id;
};
